import { render } from "./_task-list.vue?vue&type=template&id=33d24014&lang=pug"
import script from "./_task-list.vue?vue&type=script&lang=js"
export * from "./_task-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__